import { Input } from 'react-daisyui'
import { Button } from '@/components/Button.tsx'
import { toast } from 'react-toastify'
import { useTranslation } from 'react-i18next'

export default function CopyableInput({ value }: { value: string}) {
  const { t } = useTranslation()

  function onCopyLinkClick() {
    navigator.clipboard.writeText(value).then(() => {
      toast(t('common.linkCopied'), {closeButton: true, autoClose: 2000})
    })
  }

  return <div className='join flex flex-row'>
    <Input className='join-item' color='primary' value={value} onFocus={e => e.target.select()} />
    <Button color='primary' className='join-item' onClick={onCopyLinkClick}>{t('common.copyLink')}</Button>
  </div>
}
